import firebase from "firebase";

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        init(/*{commit}*/) {
            console.info('cache-store initialized.');
        },
        getAssetCacheInfo({/*commit*/}){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getAssetCacheInfo', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.text()
                                    .then((info)=>{
                                        return JSON.parse(info);
                                    })
                                    .catch((error) => {
                                        throw error
                                    })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        cacheAssets({/*commit*/}){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "PUT",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'cacheAssets', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return Promise.resolve("Success");
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
    }
}

